var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 4,
    viewBox: "0 0 4 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15545e-05 1.94682C2.15545e-05 1.67549 0.0513549 1.42249 0.154022 1.18782C0.256688 0.953154 0.396022 0.74782 0.572021 0.57182C0.748022 0.39582 0.953355 0.256487 1.18802 0.15382C1.42269 0.0511534 1.67569 -0.000179887 1.94702 -0.000179887C2.21835 -0.000179887 2.47135 0.0511534 2.70602 0.15382C2.94069 0.256487 3.14602 0.39582 3.32202 0.57182C3.49802 0.74782 3.63736 0.953154 3.74002 1.18782C3.84269 1.42249 3.89402 1.67549 3.89402 1.94682C3.89402 2.21815 3.84269 2.47115 3.74002 2.70582C3.63736 2.94049 3.49802 3.14582 3.32202 3.32182C3.14602 3.49782 2.94069 3.63715 2.70602 3.73982C2.47135 3.84249 2.21835 3.89382 1.94702 3.89382C1.67569 3.89382 1.42269 3.84249 1.18802 3.73982C0.953355 3.63715 0.748022 3.49782 0.572021 3.32182C0.396022 3.14582 0.256688 2.94049 0.154022 2.70582C0.0513549 2.47115 2.15545e-05 2.21815 2.15545e-05 1.94682Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotWhite);
export default __webpack_public_path__ + "static/media/dot-white.5646a1b89988410bcfac8dfc04d3657a.svg";
export { ForwardRef as ReactComponent };